import $ from 'jquery';
import Sloth from '../../components/Sloth';

@Sloth.component({})
export default class ImageSet {
    onInit() {
        this.adjust();

        window.addEventListener('resize', () => {
            this.adjust();
        });
    }

    adjust() {
        $(this.dom).each((index, dom) => {
            const srcPC = $(dom).data('src');
            const srcMobile = $(dom).data('alt');
            $(dom).attr('src', Sloth.isMobile() ? srcMobile : srcPC);
        });
    }
}



/** WEBPACK FOOTER **
 ** ./src/ImageSet/index.js
 **/